// extracted by mini-css-extract-plugin
export default {"container":"PgXb","feedbackWrapper":"qJe_","editBtn":"gvNC","name":"zuRY","date":"YxjE","actions":"lVeq","btn":"RDRk","blue":"OQEi","red":"nCFY","bluredFeedbackWrapper":"OR_i"};